<template>
  <div class="table-responsive px-1" style="max-height: 150px">
    <table class="table custom-group-table mb-0">
      <thead>
        <tr class="header-row">
          <th class="th-header text-center" style="width: 45px">N°</th>
          <th class="th-header" style="width: 140px">N° Serie</th>
          <th class="th-header" style="width: 140px">S. Cliente</th>
          <th class="th-header text-center" style="width: 50px">Opc.</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in neumaticoGroup"
          :key="index"
          class="group-row"
        >
          <td class="td-cell font-weight-bold text-center">
            {{ index + 1 }}
          </td>
          <td class="td-cell font-weight-medium">
            {{ item.num_serie }}
          </td>
          <td class="td-cell">
            {{ item.serie_cliente || "-" }}
          </td>
          <td class="td-cell text-center">
            <v-btn
              height="20"
              width="20"
              fab
              x-small
              color="error"
              dark
              elevation="1"
              @click="deleteItem(index)"
              title="Eliminar serie"
            >
              <v-icon x-small size="12">mdi-close</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    neumaticoGroup: Array,
  },
  data() {
    return {};
  },
  methods: {
    deleteItem: function (index) {
      this.neumaticoGroup.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.custom-group-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 4px;
}

.header-row {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  box-shadow: 0 2px 4px rgba(21, 101, 192, 0.2);
}

.th-header {
  background: transparent !important;
  color: #ffffff !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 6px 2px !important;
  border: none !important;
  white-space: nowrap;
}

.th-header:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.th-header:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.group-row {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: default;
}

.group-row:hover {
  background-color: #f0f7ff !important;
  box-shadow: 0 4px 10px rgba(25, 118, 210, 0.22) !important;
  transform: translateY(-1px);
}

.td-cell {
  font-size: 11.5px !important;
  padding: 6px 8px !important;
  border: none !important;
  vertical-align: middle !important;
}

.td-cell:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.td-cell:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
